import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Calendar
const Calendar = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Buttons.vue");
const Cards = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Cards.vue");
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/GridSystem.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );

// Forms pages
const FormElements = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormElements.vue");
const FormComponents = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormComponents.vue");
const FormValidation = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormValidation.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/GoogleMaps.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Home = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/RegularTables.vue");
const SortableTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/SortableTables.vue");
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/PaginatedTables.vue");

const dtacPackage = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/PackageTables.vue");

const dtacCreatePackage = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/CreatePackage.vue");

const dtacVoiceMail = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/VoiceMailTables.vue");

const dtacRecord = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/RecordTables.vue");

const dtacUser = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/UserTables.vue");

const dtacMappingNumber = () =>
  import(
    /* webpackChunkName: "tables" */ "@/views/Dtac/NumberMappingTables.vue"
  );

const dtacReport = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/ReportTables.vue");

// const dtacVoiceMailCorporate = () =>
//   import(
//     /* webpackChunkName: "tables" */ "@/views/Dtac/VoiceMailTablesCorporate.vue"
//   );

// const dtacRecordCorporate = () =>
//   import(
//     /* webpackChunkName: "tables" */ "@/views/Dtac/RecordTablesCorporate.vue"
//   );

const dtacUserCorporate = () =>
  import(
    /* webpackChunkName: "tables" */ "@/views/Dtac/UserTablesCorporate.vue"
  );

const dtacCreateUser = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/CreateUser.vue");

const dtacCorporateMockup = () =>
  import(
    /* webpackChunkName: "tables" */ "@/views/Dtac/CorporateMockupTables.vue"
  );

const dtacMLHG = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/MLHG.vue");

const dtacMLHGNumber = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/MLHGNumber.vue");

const dtacChangePassword = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/ChangePassword.vue");

const dtacChangeProfile = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/ChangeProfile.vue");

const ForgotPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ForgotPassword.vue");
const ResetPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ResetPassword.vue");
const MaintenancePage = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/MaintenancePage.vue");
const MaintenanceUnlock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/MaintenanceUnlock.vue");

const dtacImportNumber = () =>
  import(
    /* webpackChunkName: "tables" */ "@/views/Dtac/ImportNumberTables.vue"
  );

// v4 (EAS-server-aware) variants
const dtacCorporateV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/CorporateTablesV4.vue");
const dtacCreateCorporateV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/CreateCorporateV4.vue");
const dtacPilotNumberV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/PilotNumberTablesV4.vue");
const dtacCreatePilotNumberV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/CreatePilotNumberV4.vue");
const dtacNumberV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/NumberTablesV4.vue");
const dtacCreateNumberV4 = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/CreateNumberV4.vue");
const dtacCapacityReport = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/CapacityReport.vue");
const dtacLogsTables = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/LogsTables.vue");
const dtacMigrationTools = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/MigrationTools.vue");
const dtacEasMigration = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/EasMigration.vue");
const dtacVoicemailBackupLog = () =>
  import(/* webpackChunkName: "v4" */ "@/views/Dtac/VoicemailBackupLog.vue");

let dtacMenu = {
  path: "/portal",
  component: DashboardLayout,
  redirect: "/portal/corporate",
  name: "bc_portal",
  meta: {
    breadcrumb: "bc_portal"
  },
  children: [
    {
      path: "profile/changepassword",
      name: "change_password",
      component: dtacChangePassword,
      meta: {
        breadcrumb: "bc_change_pass",
        requiresAuth: true
      }
    },
    {
      path: "profile",
      name: "change_profile",
      component: dtacChangeProfile,
      meta: {
        breadcrumb: "bc_change_profile",
        requiresAuth: true
      }
    },
    {
      path: "corporate/create",
      name: "corporate_create",
      component: dtacCreateCorporateV4,
      meta: {
        breadcrumb: "bc_corporate",
        requiresAuth: true
      }
    },
    {
      path: "corporate",
      name: "corporate",
      component: dtacCorporateV4,
      meta: {
        breadcrumb: "bc_corporate",
        requiresAuth: true
      }
    },
    {
      path: "package",
      name: "package",
      component: dtacPackage,
      meta: {
        breadcrumb: "bc_package",
        requiresAuth: true
      }
    },
    {
      path: "package/create",
      name: "package_create",
      component: dtacCreatePackage,
      meta: {
        breadcrumb: "bc_package",
        requiresAuth: true
      }
    },
    {
      path: "voicemail",
      name: "voicemail",
      component: dtacVoiceMail,
      meta: {
        breadcrumb: "bc_voicemail"
        // requiresAuth: true
      }
    },
    {
      path: "record/",
      name: "record",
      component: dtacRecord,
      meta: {
        breadcrumb: "bc_record",
        requiresAuth: true
      }
    },
    {
      path: "report/",
      name: "report",
      component: dtacReport,
      meta: {
        breadcrumb: "bc_report",
        requiresAuth: true
      }
    },
    {
      path: "numbermapping/",
      name: "number_mapping",
      component: dtacMappingNumber,
      meta: {
        breadcrumb: "bc_mapping_number",
        requiresAuth: true
      }
    },
    {
      path: "number/",
      name: "agent_number",
      component: dtacNumberV4,
      meta: {
        breadcrumb: "bc_agent_number",
        requiresAuth: true
      }
    },
    {
      path: "pilotnumber/",
      name: "pilot_number",
      component: dtacPilotNumberV4,
      meta: {
        breadcrumb: "bc_pilot_number",
        requiresAuth: true
      }
    },
    {
      path: "importnumber/",
      name: "import_number",
      component: dtacImportNumber,
      meta: {
        breadcrumb: "bc_import_number",
        requiresAuth: true
      }
    },

    {
      path: "number/create",
      name: "number_create",
      component: dtacCreateNumberV4,
      meta: {
        breadcrumb: "bc_agent_number",
        requiresAuth: true
      }
    },
    {
      path: "pilotnumber/create",
      name: "pilot_number_create",
      component: dtacCreatePilotNumberV4,
      meta: {
        breadcrumb: "bc_pilot_number",
        requiresAuth: true
      }
    },
    {
      path: "capacity",
      name: "capacity",
      component: dtacCapacityReport,
      meta: { breadcrumb: "bc_capacity", requiresAuth: true }
    },
    {
      path: "logs",
      name: "logs",
      component: dtacLogsTables,
      meta: {
        breadcrumb: "bc_logs",
        requiresAuth: true,
        isDtacAdmin: true
      }
    },
    {
      path: "migration",
      name: "migration",
      component: dtacMigrationTools,
      meta: {
        breadcrumb: "bc_migration",
        requiresAuth: true,
        isDtacAdmin: true
      }
    },
    {
      // EAS migration (#35, re-gated in #47). NOT a GroupId check: access is an
      // explicit allow-list of usernames in the API's config.yml, surfaced as
      // Auth/isMigrationUser. Being a DTAC admin no longer grants it and is no
      // longer required — the operation deletes and recreates every EAS object
      // a corporate owns, so the people who may run it are named one by one.
      //
      // isMigrationUser REPLACES isDtacAdmin here and must never sit alongside
      // it: ROLE_RULES in navigationGuard.js is first-match-wins, not additive,
      // so a second role meta would simply be ignored.
      path: "easmigration",
      name: "eas_migration",
      component: dtacEasMigration,
      meta: {
        breadcrumb: "bc_easmigration",
        requiresAuth: true,
        isMigrationUser: true
      }
    },
    {
      // Voicemail backup / restore log. Behind the SAME gate as the EAS
      // migration above, and for the same reason: Restore writes to LIVE
      // mailboxes on the switch. It merges rather than overwrites — existing
      // messages are kept and a repeat run is a no-op — so it is recoverable
      // in a way the migration is not; but "recoverable" is not "harmless",
      // because a restore fired at the wrong corporate still puts messages in
      // mailboxes that never held them. isMigrationUser
      // is the config.yml allow-list, not a GroupId — and, as above, it must be
      // the only role meta on this route, because ROLE_RULES in
      // navigationGuard.js is first-match-wins rather than additive.
      path: "voicemail/backuplog",
      name: "voicemail_backup_log",
      component: dtacVoicemailBackupLog,
      meta: {
        breadcrumb: "bc_voicemaillog",
        requiresAuth: true,
        isMigrationUser: true
      }
    },
    {
      path: "users/",
      name: "user",
      component: dtacUser,
      meta: {
        breadcrumb: "bc_user",
        requiresAuth: true
      }
    },
    {
      path: "users/corporate",
      name: "user_corporate",
      component: dtacUserCorporate,
      meta: {
        breadcrumb: "bc_user",
        requiresAuth: true
      }
    },
    {
      path: "users/create",
      name: "user_create",
      component: dtacCreateUser,
      meta: {
        breadcrumb: "bc_user",
        requiresAuth: true
      }
    },
    {
      path: "mlhg",
      name: "mlhg",
      component: dtacMLHG,
      meta: {
        breadcrumb: "bc_mlhg",
        requiresAuth: true
      }
    },
    {
      path: "mlhg/number",
      name: "mlhg_number",
      component: dtacMLHGNumber,
      meta: {
        breadcrumb: "bc_mlhg",
        requiresAuth: true
      }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/forgotpassword",
      name: "forgot_password",
      component: ForgotPassword,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/resetpassword",
      name: "reset_password",
      component: ResetPassword,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/home",
      name: "Home",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/maintenance",
      name: "Maintenance",
      component: MaintenancePage,
      meta: { noBodyBackground: true, guest: true }
    },
    {
      path: "/login/maintenance/:key",
      name: "MaintenanceUnlock",
      component: MaintenanceUnlock,
      meta: { noBodyBackground: true, guest: true }
    },
    { path: "*", component: NotFound }
  ]
};

const routes = [
  dtacMenu,
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  // mapsMenu,
  // pagesMenu,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/portal",
    name: "Dashboard layout"
    // children: [
    //     {
    //       path: "dashboard",
    //       name: "Dashboard",
    //       component: Dashboard
    //     },
    //     {
    //       path: "alternative",
    //       name: "Alternative",
    //       component: AlternativeDashboard,
    //       meta: {
    //         navbarType: "light"
    //       }
    //     },
    //     {
    //       path: "calendar",
    //       name: "Calendar",
    //       component: Calendar
    //     },
    // {
    //   path: "charts",
    //   name: "Charts",
    //   component: Charts
    // },
    //     {
    //       path: "widgets",
    //       name: "Widgets",
    //       component: Widgets
    //     }
    // ]
  },
  authPages
];

export default routes;
